import { render, staticRenderFns } from "./ConfirmExercise.vue?vue&type=template&id=0a70ae8b&scoped=true"
import script from "./ConfirmExercise.vue?vue&type=script&lang=js"
export * from "./ConfirmExercise.vue?vue&type=script&lang=js"
import style0 from "./ConfirmExercise.vue?vue&type=style&index=0&id=0a70ae8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70ae8b",
  null
  
)

export default component.exports